import React, { useEffect, useState } from "react";
import { Button, Flex, Table, Tag, Dropdown } from "antd";
import CustomHeader from "../../components/header/CustomHeader";
import CreateCampaignDrawer from "./CreateCampaignDrawer";
import api from "../../api";
import { formatCurrency, formatDateTime } from "../../utilities/utils";
import { IconArrowRight } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";

export default function Reward() {
  const [showDrawer, setShowDrawer] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const navigate = useNavigate();

  const [items, setItems] = useState([]);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(20);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);

  const fetchCampaigns = async (p = page, l = limit) => {
    try {
      setLoading(true);
      const res = await api.get_campaign_list({ page: p, limit: l });

      // console.log("fetchCampaigns res --->", res);
      const data = res?.data || [];
      setItems(data.items || []);
      setTotal(data.meta?.total || 0);
      setPage(data.meta?.page || p);
      setLimit(data.meta?.limit || l);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCampaigns(page, limit);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, limit]);

  const onTableChange = (pagination) => {
    setPage(pagination.current);
    setLimit(pagination.pageSize);
  };

  const StatusTag = ({ status }) => {
    const colorMap = {
      active: "green",
      draft: "default",
      paused: "orange",
      ended: "red",
    };
    return <Tag color={colorMap[status] || "default"}>{status}</Tag>;
  };

  const ModeTag = ({ mode }) => (
    <Tag color={mode === "STEP" ? "blue" : "purple"}>{mode}</Tag>
  );

  const columns = [
    {
      title: "Нэр",
      dataIndex: "name",
      key: "name",
      render: (t) => <strong>{t}</strong>,
    },
    {
      title: "Горим",
      dataIndex: "mode",
      key: "mode",
      width: 140,
      render: (_, r) => <ModeTag mode={r.mode} />,
    },
    {
      title: "Дүн",
      dataIndex: "amount",
      key: "amount",
      width: 140,
      render: (v) => formatCurrency(v),
    },
    {
      title: "Тасалбар",
      dataIndex: "bonusTickets",
      key: "bonusTickets",
      width: 100,
      render: (v) => v + " ш",
    },
    // {
    //   title: "Trigger сугалаа",
    //   dataIndex: "triggerLotteryId",
    //   key: "triggerLotteryId",
    //   ellipsis: true,
    //   render: (v) => (v ? v : <Tag>All</Tag>),
    // },
    // {
    //   title: "Бонус сугалаа",
    //   dataIndex: "bonusLotteryId",
    //   key: "bonusLotteryId",
    //   ellipsis: true,
    //   render: (v) => v || "—",
    // },
    {
      title: "Хугацаа",
      key: "window",
      render: (_, r) => {
        const date =
          r?.start_at && r.end_at
            ? `${formatDateTime(r.start_at)} - ${formatDateTime(r.end_at)}`
            : "-";
        return <span>{date}</span>;
      },
    },
    {
      title: "Төлөв",
      dataIndex: "status",
      key: "status",
      width: 120,
      render: (s) => <StatusTag status={s} />,
    },
    {
      title: "Үүссэн",
      dataIndex: "created_at",
      key: "created_at",
      render: (v) => formatDateTime(v),
      sorter: false,
    },
    {
      title: "Үйлдэл",
      key: "actions",
      width: 150,
      render: (_, record) => {
        const items = (record) => [
          {
            key: "edit",
            label: (
              <span style={{ color: "black", fontSize: "13px" }}>Засах</span>
            ),
          },
          {
            key: "log",
            label: (
              <span style={{ color: "black", fontSize: "13px" }}>Лог</span>
            ),
          },
        ];

        return (
          <Dropdown
            menu={{
              items: items(record),
              onClick: ({ key }) => {
                if (key === "log") {
                  navigate(`/reward/${record.id}`);
                } else if (key === "edit") {
                  setSelectedRecord(record);
                  setShowDrawer(true);
                }
              },
            }}
            trigger={["click"]}
          >
            <Button
              variant="filled"
              color="default"
              style={{ padding: "0 20px", fontSize: "12px" }}
            >
              Үйлдэл
              <IconArrowRight size={12} />
            </Button>
          </Dropdown>
        );
      },
    },
  ];

  return (
    <Flex vertical gap={10}>
      <CustomHeader
        title={"Урамшууллын жагсаалт"}
        rightSide={
          <Button
            type="dashed"
            onClick={() => {
              setSelectedRecord(null);
              setShowDrawer(true);
            }}
            style={{ padding: "0 30px", minHeight: "40px" }}
          >
            + Урамшуулал нэмэх
          </Button>
        }
      />

      <Table
        rowKey="id"
        columns={columns}
        dataSource={items}
        loading={loading}
        onChange={onTableChange}
        pagination={{
          current: page,
          pageSize: limit,
          total,
          showSizeChanger: true,
          pageSizeOptions: [10, 20, 50, 100],
          showTotal: (t) => `Нийт ${t}`,
        }}
        scroll={{ x: 1000 }}
      />

      {/* CREATE / EDIT DRAWER */}
      <CreateCampaignDrawer
        open={showDrawer}
        record={selectedRecord}
        onClose={() => {
          setShowDrawer(false);
          setSelectedRecord(null);
        }}
        // амжилттай хадгалсны дараа жагсаалтыг шинэчлэх бол:
        onSuccess={() => fetchCampaigns(1, limit)}
      />
    </Flex>
  );
}
